module.exports = {
	"shared.crew.original-music-composer": "Original Music/Composer",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "Publicist",
	"share-overlay.share": "Share this video",
	"shared.crew.associate-producer": "Associate Producer",
	"shared.crew.assistant-editor": "Assistant Editor",
	"overlay.buy-from": "Buy from {price}",
	"shared.crew.agent": "Agent",
	"shared.crew.additional-photography": "Additional Photography",
	"shared.crew.sound-editor": "Sound Editor",
	"shared.crew.print-shipper": "Print Shipper",
	"shared.crew.hairstylist": "Hairstylist",
	"shared.crew.makeup-effects": "Makeup Effects",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "Production Assistant",
	"shared.crew.executive-producer": "Executive Producer",
	"shared.crew.costumer": "Costumer",
	"info-overlay.cast": "cast",
	"shared.crew.stunt-coordinator": "Stunt Coordinator",
	"shared.crew.academic-advisor": "Academic Advisor",
	"shared.crew.swing-gang": "Swing Gang",
	"shared.crew.best-boy": "Best Boy",
	"actions.purchased": "You own this video",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "Set Decorator",
	"shared.crew.adaptation": "Adaptation",
	"shared.crew.school-administrator": "School Administrator",
	"shared.crew.cable-person": "Cable Person",
	"shared.crew.digital-effects": "Digital Effects",
	"actions.rent": "Rent {price}",
	"info-overlay.created-by": "By {author}",
	"social-share.twitter": "Watch \"{title}\" on {siteUrl}",
	"shared.crew.production-designer": "Production Designer",
	"info-overlay.crew": "crew",
	"shared.crew.producer": "Producer",
	"shared.crew.2nd-unit-dir-of-photography": "2nd Unit Dir of Photography",
	"shared.crew.special-effects": "Special Effects",
	"actions.rented": "Rented until {date}",
	"shared.crew.boom-operator": "Boom Operator",
	"shared.crew.story": "Story",
	"shared.crew.script-supervisor": "Script Supervisor",
	"shared.crew.director": "Director",
	"shared.crew.choreographer": "Choreographer",
	"shared.crew.production-manager": "Production Manager",
	"quality.auto": "Auto",
	"shared.crew.lead-person": "Lead Person",
	"shared.crew.location-manager": "Location Manager",
	"shared.crew.costume-designer": "Costume Designer",
	"fullscreen.exit": "Exit full screen",
	"shared.crew.technical-advisor": "Technical Advisor",
	"shared.crew.editor": "Editor",
	"shared.crew.additional-grip": "Additional Grip",
	"actions.buy": "Buy {price}",
	"shared.crew.assistant-camera": "Assistant Camera",
	"shared.crew.writer": "Writer",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "Collaborating Director",
	"fullscreen.enter": "Full screen",
	"shared.crew.animal-trainer": "Animal Trainer",
	"shared.crew.assistant-art-director": "Assistant Art Director",
	"shared.crew.key-grip": "Key Grip",
	"social-button.copy": "Copy",
	"shared.crew.makeup-artist": "Makeup Artist",
	"overlay.source-error": "Video cannot be played",
	"social-button.link": "Link",
	"actions.buy-from": "Buy from {price}",
	"shared.crew.art-director": "Art Director",
	"shared.crew.production-coordinator": "Production Coordinator",
	"shared.crew.co-director": "Co-Director",
	"shared.crew.co-producer": "Co-Producer",
	"shared.crew.video-operator": "Video Operator",
	"shared.crew.camera-operator": "Camera Operator",
	"shared.crew.co-writer": "Co-Writer",
	"shared.crew.set-designer": "Set Designer",
	"shared.crew.preview-return": "Preview Return",
	"shared.crew.property-master": "Property Master",
	"shared.crew.cinematographer-dp": "Cinematographer/DP",
	"shared.crew.grip": "Grip",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "Sound Mixer",
	"quality.label": "Quality",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Gaffer",
	"shared.crew.assistant-director": "Assistant Director",
	"actions.subscribe": "Subscribe {price}/month",
	"shared.crew.print-return": "Print Return",
	"shared.crew.animator": "Animator",
	"shared.crew.dolly-grip": "Dolly Grip",
	"shared.crew.manager": "Manager",
	"shared.crew.2nd-assistant-director": "2nd Assistant Director",
	"shared.crew.author-of-adapted-material": "Author of Adapted Material"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_fi.json
// module id = 1438
// module chunks = 0 1 2 3